import { sendToShell } from "@insite/client-framework/Components/ShellHole";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { SessionModel } from "@insite/client-framework/Types/ApiModels";

export interface CreateSessionApiParameter {
    userName: string;
    password?: string;
    rememberMe?: boolean;
    keepMeSignedIn?: boolean;
    returnUrl?: string | undefined;
    isGuest?: boolean;
    accessToken: string;
}

export type Session = Omit<SessionModel, "billTo" | "shipTo"> & {
    billToId?: string;
    shipToId?: string;
};


function getHeader(accessToken: string | undefined) {
    const header = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
    } as any;

    if (accessToken) {
        header["authorization"] = `Bearer ${accessToken}`;
    }

    return header;
}

function cleanSession(session: SessionModel) {
    if (session.billTo) {
        (session as Session).billToId = session.billTo.id;
        session.billTo = null;
    }

    if (session.shipTo) {
        (session as Session).shipToId = session.shipTo.id;
        session.shipTo = null;
    }
}

function informShell(session: SessionModel) {
    sendToShell({
        type: "FrontEndSessionLoaded",
        personas: session.personas,
    });
}
const sessionsUrl = "/api/salesforcelogin";

export async function createSession(token: string, customerNumber:string): Promise<ServiceResult<boolean>> {

    const response = await fetch(sessionsUrl, {
        method: "POST",
        body: JSON.stringify({ accessToken: token, customerNumber }),
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
        }
    });

    if (!response.ok) {
        return {
            successful: false,
            errorMessage: 'not valid',
            statusCode: response.status,
        };
    }

    return {
        successful: true,
        result: true,
    };
}